import { useCreateComparatorOptions } from './useCreateComparatorOptions';
import { ComparatorSelectType } from '../types';
import { useIsOneOfCondition } from '../../hooks';
import { AnyComparator, IsOneOfComparator } from '../../../../types';
import { SelectOption } from '../../../../contexts';
import { useIsCatalogESIndex } from '../../../../hooks/useIsCatalogESIndex';

/** adds both isOneOf and isNotOneOf */
export const useIsOneOfComparatorOptions = (): SelectOption<AnyComparator>[] => {
  const createComparatorOptions = useCreateComparatorOptions();
  const isIsOneOfCondition = useIsOneOfCondition();
  const isCatalogESIndex = useIsCatalogESIndex();
  const isOneOfComparatorOptions = createComparatorOptions(
    IsOneOfComparator,
    ComparatorSelectType.isOneOf,
  );

  return isIsOneOfCondition && !isCatalogESIndex ? isOneOfComparatorOptions : [];
};
